import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { volumes } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-gray-50 py-16 md:py-24" data-id="element-221" data-mp="101x1mlkvw7ug">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-222" data-mp="l4ecvj87hun0">
        <header className="mx-auto max-w-4xl text-center" data-id="element-223" data-mp="q265ygkl7mss">
          <p className="text-sm font-bold uppercase tracking-widest text-blue-600" data-id="element-224" data-mp="q2od488sflfh">
            Sistema Completo
          </p>
          <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 md:text-5xl" data-id="element-225" data-mp="1ir3omkspnlm2">
            6 Tomos de Instrumentación Quirúrgica
          </h2>
        </header>

        <ul className="mx-auto mt-12 grid gap-5 md:grid-cols-2" data-id="element-226" data-mp="140cv98bh0egu">
          {volumes.map(volume => <li key={volume.tag} className={`flex h-full flex-col rounded-xl bg-white p-6 shadow-sm ring-1 md:p-8 ${volume.featured ? 'ring-2 ring-blue-600 md:col-span-2' : 'ring-gray-200'}`} data-id="element-227" data-mp="1wquyc9c72fu9">
              <p className="text-sm font-bold uppercase tracking-wider text-blue-600" data-id="element-228" data-mp="2vgc4donhmo22">
                {volume.tag}
              </p>
              <h3 className="mt-2 text-xl font-extrabold tracking-tight text-gray-900 md:text-2xl" data-id="element-229" data-mp="355n96z3cd6k5">
                {volume.title}
              </h3>

              <div className="mt-4 space-y-3 text-gray-600" data-id="element-230" data-mp="30e58mc58d7zp">
                {volume.paragraphs.map((paragraph, index) => <p key={paragraph} className={index === 0 && volume.featured ? 'font-semibold text-gray-900' : ''} data-id="element-231" data-mp="3e8el1004q4cb" data-mpi={index}>
                    {paragraph}
                  </p>)}
              </div>

              {volume.items && <ul className={`mt-5 grid gap-x-6 gap-y-2.5 ${volume.featured ? 'sm:grid-cols-2 lg:grid-cols-4' : 'sm:grid-cols-2'}`} data-id="element-232" data-mp="3j3bwedkvspsd">
                  {volume.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-233" data-mp="2egudvu0hjkbe">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600" data-id="element-234" data-mp="2igl0rmmw5gan">
                        <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-235" data-mp="2new9tv5d3mrt" />
                      </span>
                      <span className="text-sm text-gray-900" data-id="element-236" data-mp="2sglkh9oo9yfd">{item}</span>
                    </li>)}
                </ul>}

              {volume.flow && <ol className="mt-5 flex flex-wrap items-center gap-x-2 gap-y-2" data-id="element-237" data-mp="31efe2cv1ydyu">
                  {volume.flow.map((step, index) => <li key={step} className="inline-flex items-center gap-2" data-id="element-238" data-mp="3b5s6b5krj65e" data-mpi={index}>
                      <span className="rounded-md bg-blue-50 px-2.5 py-1 text-sm font-semibold text-blue-800" data-id="element-239" data-mp="3b7mjtytpfvzg">
                        {step}
                      </span>
                      {index < (volume.flow?.length ?? 0) - 1 && <ArrowRightIcon className="h-4 w-4 text-gray-400" aria-hidden="true" data-id="element-240" data-mp="19gw66h28n1hp" />}
                    </li>)}
                </ol>}

              {volume.closing && <div className="mt-5 space-y-3" data-id="element-241" data-mp="ziyfzo0tiumg">
                  {volume.closing.map(line => <p key={line} className="text-gray-600" data-id="element-242" data-mp="ul6fi5m3y06n">
                      {line}
                    </p>)}
                </div>}
            </li>)}
        </ul>
      </div>
    </section>;
}